import { type ReactNode } from 'react';

import { Sheet } from '@/ui/primitives/sheet';
import { Skeleton } from '@/ui/primitives/skeleton';

interface GavetaDetalheProps {
  aberta: boolean;
  aoFechar: () => void;
  titulo: ReactNode;
  subtitulo?: ReactNode;
  carregando?: boolean;
  /** Mensagem quando o detalhe falhou ao carregar. */
  erro?: ReactNode;
  children: ReactNode;
}

/**
 * Detalhe de um item da lista sem sair dela. Usa o nome de View Transition `detalhe`: a linha
 * clicada recebe o mesmo nome por um instante e a gaveta "nasce" dela.
 */
export function GavetaDetalhe({
  aberta,
  aoFechar,
  titulo,
  subtitulo,
  carregando,
  erro,
  children,
}: GavetaDetalheProps) {
  return (
    <Sheet
      aberto={aberta}
      aoMudar={(valor) => {
        if (!valor) aoFechar();
      }}
      titulo={titulo}
      descricao={subtitulo}
      nomeTransicao="detalhe"
    >
      <div className="grid gap-6 px-6 py-5">
        {carregando ? <EsqueletoDetalhe /> : (erro ?? children)}
      </div>
    </Sheet>
  );
}

function EsqueletoDetalhe() {
  return (
    <div className="grid gap-4" aria-label="Carregando detalhe">
      <Skeleton className="h-6 w-1/2" />
      <div className="grid grid-cols-2 gap-3">
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} className="h-12" />
        ))}
      </div>
      <Skeleton className="h-40" />
    </div>
  );
}
